module.exports = __webpack_public_path__ + "static/img/14000483.b69f27b9.png";